import React, { useContext } from 'react';

import FilterChip from '@totem/components/ui_components/filters/FilterChip';
import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import { isNotNull } from '@totem/utilities/common';

const styles = {
  chipsContainer: {
    //marginTop: '.25rem',
    marginBottom: '1rem',
  },
  filterChip: {
    marginRight: '1rem',
    marginTop: '.5rem',
  },
};

const FilterChips = () => {
  const { input, handleFilter } = useContext(InputContext);
  return (
    <div style={styles.chipsContainer}>
      {input.filters
        .filter(
          (filter) =>
            filter.multiple &&
            filter.values.length > 0 &&
            !(isNotNull(filter.hideFilterChips) && filter.hideFilterChips),
        )
        .map((filter) => {
          return (
            <span key={filter.key}>
              {filter.values.map((value) => {
                return (
                  <FilterChip
                    key={`${filter.key}_${value.value}`}
                    label={`${filter.label}: ${value.text}`}
                    style={styles.filterChip}
                    onClose={() =>
                      handleFilter(
                        filter.key,
                        filter.values
                          .filter((chk) => chk.value !== value.value)
                          .map((val) => val.value),
                      )
                    }
                  />
                );
              })}
            </span>
          );
        })}
    </div>
  );
};

export default FilterChips;
